$(document).ready(function() {
    if ($(window).width() < 1024 && $('.b-game-banner__title').height() > 96) {
        $('.b-game-banner__title').addClass('low');
    } else if ($(window).width() >= 1024 && $('.b-game-banner__title').height() > 192) {
        $('.b-game-banner__title').addClass('low');
    }
});


// WEBPACK FOOTER //
// ./src/js/pages/game-one/game-title.js